import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import { useRouter } from 'next/router';
import UserPlan from '@creditflowresearch/user-plan/UserPlan';
import buildAccessibleMarketOverviewUrl
  from '@/creditflowresearch/application/Preferences/buildAccessibleMarketOverviewUrl';

const useGetHomePageUrl = (): string | null => {
  const { plan, preferences, products, regions } = useUserPlanContext();
  const { asPath } = useRouter();

  if (UserPlan.isSatisfiedStarterPlan(plan) && preferences) {
    const homePageUrl = buildAccessibleMarketOverviewUrl({ preferences, products, regions });

    return homePageUrl === asPath ? null : homePageUrl;
  }

  return '/';
};

export default useGetHomePageUrl;
